import * as React from 'react';
import { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TuneIcon from '@mui/icons-material/Tune';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FilterTask from './FilterTask';
import { getUserTasks } from '../../../services/UserService';
import KeycloakService from '../../../services/KeycloakService';
import ErrorSwitchCase from '../../../services/ErrorHandlerService';
import { useDispatch } from 'react-redux';
import DeletableChips from '../../../components/Chip/DeletableChip';
import { RESET_DATE_RANGE, SHOW_NOTIFICATION } from '../../../constants';
import { TaskType } from '../TaskConstants';

const drawerWidth = 340;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

export default function FilterDrawer(props) {
  const currentUserId = () => KeycloakService.getUserDetail();
  const [resetDateRange, setResetDateRange] = React.useState(false);
  const [activeFilters, setActiveFilters] = React.useState({});
  const dispatch = useDispatch();

  const [clear, setClear] = useState(false);
  const {
    closeFilterTask,
    handleDataOfFilter,
    setShowHideDateRange,
    showHideDateRange,
    filterData,
    setFilterData,
    userProjects,
    setRows,
    rows,
    isRender,
    openDrawer,
    setOpenDrawer,
    setPageNo,
    pageNo,
    setPage,
    setTotalPage,
    isFilterEmpty,
  } = props;
  const theme = useTheme();
  const handleDrawerOpen = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handleNotifications = async (filterData) => {
    const filteredTask = await getUserTasks(
      currentUserId(),
      filterData,
      filterData.appraisal,
      4,
      0,
    );
    if (filteredTask.isError === false) {
      setPageNo(0);
      setPage(1);
      setTotalPage(filteredTask.data.totalPages);
      setRows(filteredTask.data.content);
      setShowHideDateRange(false);
    }
    if (filteredTask.status !== 200) {
      dipatchNotification(filteredTask.type, filteredTask.message);
    }
  };

  const handleActiveFilters = (filterData) => {
    let activeFilters = {};
    for (let key in filterData) {
      if (filterData[key] === '') continue;
      activeFilters[key] = filterData[key];
    }
    setActiveFilters(activeFilters);
  };

  const handleFilterForTask = async () => {
    handleNotifications(filterData);
    handleActiveFilters(filterData);
    handleDrawerClose();
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const resetFilterData = async () => {
    //this function does reset fields + submit
    const newFilterData = {
      taskTitle: '',
      taskType: '',
      projectFilter: '',
      projectName: '',
      startDate: '',
      endDate: '',
      appraisal: false,
    };
    setFilterData(() => {
      return newFilterData;
    });
    dispatch({
      type: RESET_DATE_RANGE,
    });
    setActiveFilters({});
    handleNotifications(newFilterData);
  };

  const handleDeleteActiveFilter = async (key) => {
    let newFilterData = { ...filterData };
    if (key === 'dateRange') {
      newFilterData['startDate'] = '';
      newFilterData['endDate'] = '';
    } else if (key === 'projectName') {
      newFilterData['projectFilter'] = '';
      newFilterData['projectName'] = '';
    } else {
      newFilterData[key] = '';
    }
    setFilterData(newFilterData);
    if (key === 'dateRange') {
      dispatch({
        type: RESET_DATE_RANGE,
      });
    }
    handleActiveFilters(newFilterData);
    handleNotifications(newFilterData);
    setPage(1);
  };

  const getActiveFilterArray = () => {
    let startDate = null;
    let endDate = null;
    let activeFiltersArray = [];
    Object.entries(activeFilters).map((entry) => {
      if (entry[0] === 'projectFilter') return;
      if (entry[0] === 'appraisal') {
        if (entry[1] === true) entry[1] = 'Appraisable';
        else return;
      }
      if (entry[0] === 'startDate') {
        startDate = entry[1];
        return;
      }
      if (entry[0] === 'endDate') {
        endDate = entry[1];
        return;
      }
      if (entry[0] === 'taskType') {
        let temp = TaskType(entry[1]);
        entry[1] = temp;
      }
      activeFiltersArray.push([entry[0], entry[1]]);
    });
    if (startDate !== null) {
      activeFiltersArray.push(['dateRange', startDate + ' - ' + endDate]);
    }
    return activeFiltersArray;
  };
  const [filterIconVisible, setFilterIconVisible] = useState(true);

  React.useEffect(() => {
    setFilterIconVisible(checkFilterIconVisibility());
  }, [rows]);

  const checkFilterIconVisibility = () => {
    const x = isFilterEmpty();
    const y = rows.length === 0;
    if (x & y) return false;
    return true;
  };
  return (
    <>
      {filterIconVisible && (
        <IconButton
          tabIndex={0}
          title="Filter"
          aria-label="Filter"
          variant="standard"
          onClick={handleDrawerOpen}
        >
          {' '}
          <TuneIcon fontSize="medium" sx={{ transform: 'scaleZ(-1 )' }} />
        </IconButton>
      )}

      {getActiveFilterArray().map((entry) => {
        return (
          <DeletableChips
            chipValue={entry[1]}
            chipKey={entry[0]}
            deleteChip={handleDeleteActiveFilter}
          />
        );
      })}
      <Box sx={{ display: 'flex' }}>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
            },
          }}
          variant="persistent"
          anchor="right"
          open={openDrawer}
        >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
            <IconButton
              onClick={resetFilterData}
              style={{ marginLeft: 'auto' }}
            >
              <RestartAltIcon />
            </IconButton>
          </DrawerHeader>
          <Divider />
          <FilterTask
            closeFilterTask={closeFilterTask}
            showHideDateRange={showHideDateRange}
            setShowHideDateRange={setShowHideDateRange}
            userProjects={userProjects}
            isRender={isRender}
            handleDataOfFilter={handleDataOfFilter}
            filterData={filterData}
            setFilterData={setFilterData}
            setRows={setRows}
            resetFilterData={resetFilterData}
            handleDrawerOpen={handleDrawerOpen}
            dipatchNotification={dipatchNotification}
            handleFilterForTask={handleFilterForTask}
            resetDateRange={resetDateRange}
            setResetDateRange={setResetDateRange}
            setPageNo={setPageNo}
          />
        </Drawer>
      </Box>
    </>
  );
}
